function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M81.217 45.3114L101.638 76.9571L79.9999 91.9685L57.9562 76.8219L78.2421 45.3114C78.918 44.2295 80.541 44.2295 81.217 45.3114Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M81.3525 114.689L102.99 81.0142C103.021 80.9525 103.045 80.8908 103.068 80.8309C103.104 80.7381 103.138 80.6492 103.195 80.57L81.3525 95.62C81.2676 95.6482 81.1888 95.6764 81.1134 95.7033L81.1115 95.704C80.8268 95.806 80.5909 95.8904 80.2706 95.8904C79.8647 95.8904 79.4591 95.8904 79.1884 95.62L56.4686 79.9324C56.4686 80.3379 56.4686 80.7438 56.7391 81.0142L78.3773 114.689C78.6476 115.229 79.1884 115.5 79.8647 115.5C80.4058 115.5 81.0818 115.229 81.3525 114.689Z",
  fill: "white"
});

function SvgCoinIconEth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinIconEth);
export default __webpack_public_path__ + "static/media/CoinIconETH.20f1cdf4.svg";
export { ForwardRef as ReactComponent };